<template>
  <div class="page-content">
    <div class="page-banner committees_banner">
      <div class="page-banner-content">
        <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>COMMITTEES</p>
      </div>

    </div>
    <div class="main-container">
      
      <div class="content-item-grp" v-show="true">
        <div class="content-item">
          <div class="item-title">
            <span class=" item-title-content">大会主席<span class="pc-browser"></span></span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                白&nbsp;&nbsp;&nbsp;&nbsp;翔
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                夏桂松
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                武汉大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                张敏灵
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                东南大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                汤&nbsp;&nbsp;&nbsp;&nbsp;进
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                安徽大学
              </el-col>
            </el-row>
            
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">程序委员会主席<span class="pc-browser"></span></span>
          </div>
          <div class="item-content">
            
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                许永超
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                武汉大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                朱盈盈
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                张洪艳
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国地质大学（武汉）
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                徐天阳
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                江南大学
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">Workshop 主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                郭裕兰
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中山大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                郭春乐
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                南开大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                唐&nbsp;&nbsp;&nbsp;&nbsp;厂
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                王楠楠
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                西安电子科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                刘禹良
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                沈&nbsp;&nbsp;&nbsp;&nbsp;为
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                上海交通大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                苏&nbsp;&nbsp;&nbsp;&nbsp;航
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                清华大学
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">APR 主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                魏秀参
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                东南大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                张姗姗
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                南京理工大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                胡&nbsp;&nbsp;&nbsp;&nbsp;鹏
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                四川大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                黄青虬
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                武汉大学
              </el-col>
            </el-row>
            
          </div>
        </div>
        
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">Tutorial 主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                张利军
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                南京大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                李&nbsp;&nbsp;&nbsp;&nbsp;辉
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                江南大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                王兴刚
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                左旺孟
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                哈尔滨工业大学
              </el-col>
            </el-row>
            
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">Poster 主席</span>
          </div>
          <div class="item-content">
            
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                刘&nbsp;&nbsp;&nbsp;&nbsp;波
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                重庆邮电大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                刘袁缘
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国地质大学（武汉）
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                王&nbsp;&nbsp;&nbsp;&nbsp;正
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                武汉大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                王福田
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                安徽大学
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">赞助主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                白&nbsp;&nbsp;&nbsp;&nbsp;翔
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                山世光
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国科学院计算技术研究所
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                程明明
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                南开大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                姬艳丽
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中山大学
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">宣传主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                贾&nbsp;&nbsp;&nbsp;&nbsp;伟
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                合肥工业大学
              </el-col>
            </el-row>
            
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                郑&nbsp;&nbsp;&nbsp;&nbsp;乾
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                浙江大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                朱&nbsp;&nbsp;&nbsp;&nbsp;磊
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                同济大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                余&nbsp;&nbsp;&nbsp;&nbsp;磊
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                武汉大学
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">展览主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                刘夏雷
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                南开大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                孙&nbsp;&nbsp;&nbsp;&nbsp;琨
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国地质大学（武汉）
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                夏孟涵
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
          </div>
        </div>
        
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">注册主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                郭宗辉
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国海洋大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                刘晋源
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                大连理工大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                蒋兴宇
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">网站主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                郑海永
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国海洋大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                赵&nbsp;&nbsp;&nbsp;&nbsp;洋
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                合肥工业大学
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">财务主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                朱盈盈
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                程&nbsp;&nbsp;&nbsp;&nbsp;一
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国科学院计算技术研究所
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">本地主席</span>
          </div>
          <div class="item-content">
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                冯如意
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                中国地质大学（武汉）
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                武&nbsp;&nbsp;&nbsp;&nbsp;宇
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                武汉大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                高常鑫
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="text-align-right item-content-content item-content-name">
                肖&nbsp;&nbsp;&nbsp;&nbsp;阳
              </el-col>
              <el-col :span="12"  class="text-align-left item-content-content">
                华中科技大学
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Committees"
    }
</script>

<style scoped>
  .committees_banner{
    background-image: url("../../static/images/sub_banner/01.jpg");

  }
  .page-banner-content {
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.6);
    /*opacity: 0.5;*/
  }
  .committees_banner p{
    /*color: #409EFF;*/
  }
  .main-container{
    margin: 50px auto;
    width: 500px;
  }
  .item-content-name{
    padding-right: 32px;
  }
  @media screen  and (max-width: 800px){
    .committees_banner{
      /*background-image: url("../../static/images/committees_banner_m.jpg");*/
      background-size: cover;
      background-position: 25% 100%;
    }
  }
  @media screen and (max-width: 600px){

    .main-container {
      width: 90%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Committees.vue